module.exports = __webpack_public_path__ + "img/Frog_Voucher_F.2e309ffe.png";